import * as React from 'react';
import { IgcGridToolbarActionsComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import { createComponent } from '../react-props.js';

/**
 * Provides a way to template the action portion of the toolbar in the grid.
 * @class
 */
export const IgrGridToolbarActions = /* @__PURE__ */ createComponent({
  tagName: 'igc-grid-toolbar-actions',
  displayName: 'IgrGridToolbarActions',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
});

export type IgrGridToolbarActions = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridToolbarActionsModule = Component;
